const prefs_key = "orbitPrefs";

export default {
  setConnectionSettings(settings) {
    localStorage.setItem(prefs_key, JSON.stringify(settings));
  },
  getConnectionSettings() {
    // SHOULD INCLUDE:  server_address, server_port, server_path, client_id
    return JSON.parse(localStorage.getItem(prefs_key) ?? "{}");
  },
  hasCompleteConnectionSettings() {
    const settings = this.getConnectionSettings();

    return (
      "server_address" in settings &&
      settings.server_address.length &&
      "server_port" in settings &&
      settings.server_port.length &&
      "server_path" in settings &&
      settings.server_path.length &&
      "client_id" in settings
    ); //not checking for length of client_id because it is truly an integer (so no "length" property)
  },
  generateBaseURLFromSettings() {
    const settings = this.getConnectionSettings();
    let baseUrl = "unknown_address";

    if (this.hasCompleteConnectionSettings()) {
      baseUrl = settings.server_address + (settings.server_port ? `:${settings.server_port}` : "");
    }

    // console.log("BASEURL: " + baseUrl);
    return baseUrl;
  },
};
